export default "__VITE_ASSET__PVnX5qr6__"